import L from "leaflet";
export const normalizeText = (value = "") => String(value || "").trim().toLowerCase();
export const toText = (value = "") => String(value || "").trim();

export const getCountryFromAddress = (address = {}) => toText(address?.country) || null;
export const getStateFromAddress = (address = {}) => toText(address?.state || address?.state_district || address?.region || address?.province || address?.county) || null;
export const getCityFromAddress = (address = {}) => toText(address?.city || address?.state_district || address?.county || address?.town || address?.municipality || address?.village || address?.hamlet || address?.suburb) || null;

export const normalizePlace = (place = {}) => {
    const address = place?.address || {};
    const country = getCountryFromAddress(address);
    const state = getStateFromAddress(address);
    const city = getCityFromAddress(address);
    const lat = Number.parseFloat(place?.lat);
    const lon = Number.parseFloat(place?.lon);

    return {
        ...place,
        place_id: place?.place_id,
        lat: place?.lat,
        lon: place?.lon,
        name: place?.name,
        display_name: place?.display_name,
        address,
        addresstype: place?.addresstype,
        type: place?.type,
        place_rank: place?.place_rank,
        boundingbox: Array.isArray(place?.boundingbox) ? place.boundingbox : undefined,
        location: {
            country,
            state,
            city,
            latitude: Number.isNaN(lat) ? 0 : lat,
            longitude: Number.isNaN(lon) ? 0 : lon,
            place: [city, state, country].filter(Boolean),
        },
    };
};

export const getPlaceBounds = (place) => {
    const bbox = Array.isArray(place?.boundingbox) ? place.boundingbox : null;
    if (!bbox || bbox.length < 4) return null;

    const south = Number(bbox[0]);
    const north = Number(bbox[1]);
    const west = Number(bbox[2]);
    const east = Number(bbox[3]);
    if (![south, north, west, east].every(Number.isFinite)) return null;

    const bounds = L.latLngBounds([south, west], [north, east]);
    return bounds?.isValid?.() ? bounds : null;
};